import React from "react";

/**
 * Componente que representa el formulario de alta y modificación de un
 * recurso.
 */
export default class Auditoria extends React.Component {
  render() {
    return (
      <React.Fragment>
        <h3>Información de auditoría.</h3>
        <div className="field">
          <label className="label">
            Id:&nbsp;
            <span>{this.props.data.id}</span>
          </label>
          <p className="help"> Identificador único del registro.</p>
        </div>

        <div className="field">
          <label className="label">
            Fecha de Creación:&nbsp;
            <span>{this.props.data.fecha_creacion}</span>
          </label>
          <p className="help"> Fecha de alta del registro.</p>
        </div>
        <div className="field">
          <label className="label">
            Usuario Creación:&nbsp;
            <span>{this.props.data.usuario_creacion}</span>
          </label>
          <p className="help"> Usuario que creó el registro.</p>
        </div>
        <div className="field">
          <label className="label">
            Fecha de modificación:&nbsp;
            <span>{this.props.data.fecha_modificacion}</span>
          </label>
          <p className="help"> Fecha de la última modificación del registro.</p>
        </div>
        <div className="field">
          <label className="label">
            Usuario modificación:&nbsp;
            <span>{this.props.data.usuario_modificacion}</span>
          </label>
          <p className="help">
            {" "}
            Usuario que realizó la última modificación del registro.
          </p>
        </div>
      </React.Fragment>
    );
  }
}
